module.exports = __webpack_public_path__ + "img/17.7e97a7b.jpg";